import { useState } from 'react'
import { haptic } from '../lib/telegram'
import { useSirr } from '../store'

interface Props {
  /** Оба варианта уже введены — можно раскладывать карты. */
  onReady: (first: string, second: string) => void
}

/** Больше в одну строку всё равно не читается, а в промпт уходит целиком. */
const MAX = 80

/**
 * Ввод двух вариантов для расклада «Два пути».
 *
 * Единственный расклад, которому нужны слова человека: без них карты справа
 * и слева ничем не отличаются друг от друга. Пустые поля не пропускаем —
 * расклад «остаться или остаться» бессмыслен.
 */
export function TwoPaths({ onReady }: Props) {
  const { t } = useSirr()
  const [first, setFirst] = useState('')
  const [second, setSecond] = useState('')

  const ready = first.trim().length > 0 && second.trim().length > 0

  const submit = () => {
    if (!ready) return
    haptic.impact('medium')
    onReady(first.trim(), second.trim())
  }

  return (
    <div className="paths">
      <div className="paths__intro">
        <div className="paths__title">{t('pathsTitle')}</div>
        <div className="paths__hint">{t('pathsHint')}</div>
      </div>

      <label className="paths__field">
        <span className="paths__label">{t('pathsFirst')}</span>
        <input
          className="paths__input"
          value={first}
          maxLength={MAX}
          onChange={(e) => setFirst(e.target.value)}
          placeholder={t('pathsFirstHint')}
          enterKeyHint="next"
        />
      </label>

      <div className="paths__or">{t('pathsOr')}</div>

      <label className="paths__field">
        <span className="paths__label">{t('pathsSecond')}</span>
        <input
          className="paths__input"
          value={second}
          maxLength={MAX}
          onChange={(e) => setSecond(e.target.value)}
          placeholder={t('pathsSecondHint')}
          enterKeyHint="done"
          onKeyDown={(e) => e.key === 'Enter' && submit()}
        />
      </label>

      <button type="button" className="paths__go" disabled={!ready} onClick={submit}>
        {t('pathsGo')}
      </button>
    </div>
  )
}
